import { createFileRoute } from '@tanstack/react-router'
import { LoyaltyMemberPage } from '../../../../features/loyalty/member-page'
import { loyaltyMemberQueryOptions } from '../../../../features/loyalty/queries'
import { memberPageSearchSchema } from '../../../../features/loyalty/search'

export const Route = createFileRoute('/_app/loyalty/members/$memberId')({
  staticData: { crumb: 'loyaltyMember' },
  validateSearch: memberPageSearchSchema,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(loyaltyMemberQueryOptions(params.memberId)),
  component: LoyaltyMemberPage,
})
